module.exports = __webpack_public_path__ + "img/greycard.a8faa571.png";